/*
  chapman-mloop - the phone-width brand sliders (2026-10-23, theme V2).

  Below 768px a [data-chap-loop] grid becomes two rows that slide sideways
  without end (.chap-mloop in custom.css). The tiles are cloned once (twice
  for an odd count, so the copy starts on a fresh column) and the scroll
  position wraps by one full set, so the row never runs out. It drifts slowly
  on its own and stops while a finger, the mouse or the keyboard is on it; with
  reduced motion it only moves when swiped. Clones are aria-hidden, out of the
  tab order, and hidden above 767px, so the desktop grid is untouched.
*/
(() => {
  const mq = window.matchMedia('(max-width: 767px)');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SPEED = 0.025; // px per ms, about 25px a second

  const cloneAll = (list) => list.map((n) => {
    const c = n.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.setAttribute('data-chap-clone', '');
    if (c.matches('a, button')) c.tabIndex = -1;
    c.querySelectorAll('a, button').forEach((a) => { a.tabIndex = -1; });
    return c;
  });

  const setup = (el) => {
    if (el.dataset.chapLoopReady) return;
    let set = [...el.children];
    if (set.length < 4) return;
    el.dataset.chapLoopReady = '1';
    if (set.length % 2) {
      const extra = cloneAll(set);
      extra.forEach((c) => el.appendChild(c));
      set = set.concat(extra);
    }
    cloneAll(set).forEach((c) => el.appendChild(c));
    const n = set.length;

    let period = 0;
    const measure = () => {
      period = mq.matches ? el.children[n].offsetLeft - el.children[0].offsetLeft : 0;
    };
    const wrap = () => {
      if (period <= 0) return;
      if (el.scrollLeft >= period) el.scrollLeft -= period;
      else if (el.scrollLeft <= 0) el.scrollLeft += period;
    };
    el.addEventListener('scroll', wrap, { passive: true });

    let held = false;
    let resumeAt = 0;
    const hold = () => { held = true; };
    const release = () => { held = false; resumeAt = performance.now() + 2500; };
    el.addEventListener('pointerdown', hold, { passive: true });
    el.addEventListener('touchstart', hold, { passive: true });
    el.addEventListener('pointerup', release, { passive: true });
    el.addEventListener('pointercancel', release, { passive: true });
    el.addEventListener('touchend', release, { passive: true });
    el.addEventListener('mouseenter', hold);
    el.addEventListener('mouseleave', release);
    el.addEventListener('focusin', hold);
    el.addEventListener('focusout', release);

    let visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
      }).observe(el);
    }

    let last = 0;
    let carry = 0;
    const tick = (t) => {
      const dt = last ? Math.min(t - last, 64) : 0;
      last = t;
      if (mq.matches && period > 0 && visible && !held && !still.matches && t >= resumeAt) {
        carry += SPEED * dt;
        if (carry >= 1) {
          const step = Math.floor(carry);
          carry -= step;
          el.scrollLeft += step;
        }
      }
      requestAnimationFrame(tick);
    };

    measure();
    window.addEventListener('resize', measure);
    mq.addEventListener('change', measure);
    window.addEventListener('load', measure);
    requestAnimationFrame(tick);
  };

  const init = () => document.querySelectorAll('[data-chap-loop]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
